exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".std-attribute-message-box .el-message-box__header{padding:5px 5px 10px!important}.std-attribute-message-box .el-message-box__headerbtn{top:2px!important;right:5px!important}.std-attribute-message-box .el-message-box__status{top:49.2%!important}.std-attribute-message-box .el-message-box__btns{padding:5px 5px 0!important}.dialog__import .el-dialog__body{height:450px!important}", ""]);

// exports
